const MOBILE_BP = 500;

export const checkIsMobile = () =>
  document.documentElement.clientWidth <= MOBILE_BP;
